<a
    [routerLink]="['/']"
    title="Homepage of the application"
    [ngClass]="dark ? 'sh-logo-link--dark' : 'sh-logo-link'"
    class="sh-logo-link"
    [class.-sh-compact]="compact"
>
    <img [src]="src" [alt]="alt" class="sh-logo sh-logo-link__logo" />
</a>
